class Gallery extends HTMLElement {
  constructor() {
    super();

    /** which slide are we on
     * set by which elems offset is 0 (or closest to)
     */
    this.activeSlide = 0;

    this.slider = this.querySelector('.gallery-track');

    this.items = this.slider.querySelectorAll('.gallery__item');

    this.slider.addEventListener('scrollend', this.onScrollEnd.bind(this));

    this.querySelector('button.next').addEventListener('click', this.onNextClick.bind(this));
    this.querySelector('button.prev').addEventListener('click', this.onPrevClick.bind(this));
  }

  onScrollEnd() {
    const offsets = Array.from(this.items).map((elem) => Math.floor(Math.abs(elem.getBoundingClientRect().x)));
    const current = offsets.findIndex((val) => val === 0);

    this.activeSlide = current;

    this.updateActiveSlide();
  }

  updateActiveSlide() {
    Array.from(this.items).forEach((item, index) => {
      if (index === this.activeSlide) {
        item.classList.add('gallery__item--active');
      } else {
        item.classList.remove('gallery__item--active');
      }
    });
  }

  // when moving we can just guess the next target, scroll will snap for us
  onNextClick() {
    this.slider.scrollLeft += this.slider.getBoundingClientRect().width / 2;
  }

  onPrevClick() {
    this.slider.scrollLeft -= this.slider.getBoundingClientRect().width / 2;
  }
}

customElements.define('c-gallery', Gallery);
